export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON monkey house CY.921b2e0c.png";